<template>
  <ts-loading-banner :loading="loading">
    <div class="ts-p-4">
      <table class="ts-w-full">
        <thead>
          <tr>
            <th
              class="ts-bg-gray-200 ts-py-1 ts-uppercase ts-font-semibold ts-px-2 ts-w-10"
            >
              No
            </th>
            <th
              class="ts-bg-gray-200 ts-py-1 ts-uppercase ts-font-semibold ts-px-2 ts-w-48"
            >
              Fee type
            </th>
            <th
              class="ts-bg-gray-200 ts-py-1 ts-uppercase ts-font-semibold ts-px-2 ts-w-56"
            >
              Old Fee
            </th>
            <th
              class="ts-bg-gray-200 ts-py-1 ts-uppercase ts-font-semibold ts-px-2 ts-w-56"
            >
              New Fee
            </th>
            <th
              class="ts-bg-gray-200 ts-py-1 ts-uppercase ts-font-semibold ts-px-2"
            >
              Description
            </th>
            <th
              class="ts-bg-gray-200 ts-py-1 ts-uppercase ts-font-semibold ts-px-2"
            >
              Quantity
            </th>
            <th
              class="ts-bg-gray-200 ts-py-1 ts-uppercase ts-font-semibold ts-px-2"
            >
              Fee
            </th>
            <th
              class="ts-bg-gray-200 ts-py-1 ts-uppercase ts-font-semibold ts-px-2 ts-w-40"
            >
              Start Date
            </th>
            <th
              class="ts-bg-gray-200 ts-py-1 ts-uppercase ts-font-semibold ts-px-2 ts-w-40"
            >
              end Date
            </th>
            <th
              class="ts-bg-gray-200 ts-py-1 ts-uppercase ts-font-semibold ts-px-2 ts-w-40 ts-text-right"
            >
              amount
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(detail, index) in model.inv_detail_list"
            :key="index"
            class="ts-border-b ts-border-dashed"
          >
            <td class="ts-py-1 ts-px-2">{{ index + 1 }}</td>
            <td class="ts-py-1 ts-px-2">
              <a-select
                v-model="detail.fee_type_id"
                style="width: 100%"
                :options="feeTypes"
                :disabled="true"
              />
            </td>
            <td class="ts-py-1 ts-px-2">
              <input
                :value="detail.old_fee_setup_name"
                type="text"
                class="form-control"
                readonly
              />
            </td>
            <td class="ts-py-1 ts-px-2">
              <a-select
                v-model="detail.fee_setup_id"
                style="width: 100%"
                :options="getFeeItem(detail.fee_type_id)"
                @change="(_, prop) => onFeeSetupChange(detail, prop)"
                :showSearch="true"
                :filterOption="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                "
                optionFilterProp="children"
              />
              <div
                class="validate"
                v-if="errors.has('inv_detail_list.' + index + '.fee_setup_id')"
              >
                {{ errors.first('inv_detail_list.' + index + '.fee_setup_id') }}
              </div>
            </td>
            <td class="ts-py-1 ts-px-2">
              <input
                v-model="detail.fee_description"
                type="text"
                class="form-control"
              />
            </td>
            <td class="ts-py-1 ts-px-2">
              <input
                v-model.number="detail.quantity"
                type="number"
                class="form-control ts-w-16"
                @input="calculate"
              />
              <div
                class="validate"
                v-if="errors.has('inv_detail_list.' + index + '.quantity')"
              >
                {{ errors.first('inv_detail_list.' + index + '.quantity') }}
              </div>
            </td>
            <td class="ts-py-1 ts-px-2">
              <div class="ts-flex ts-justify-between">
                <p>$</p>
                <b>{{ detail.fee_amount }}</b>
              </div>
            </td>
            <td class="ts-py-1 ts-px-2">
              <a-date-picker
                v-model="detail.fee_start_date"
                placeholder="Date To"
                valueFormat="DD-MM-YYYY"
                format="DD-MM-YYYY"
                style="width: 100%"
              />
            </td>
            <td class="ts-py-1 ts-px-2">
              <a-date-picker
                v-model="detail.fee_end_date"
                placeholder="Date To"
                valueFormat="DD-MM-YYYY"
                format="DD-MM-YYYY"
                style="width: 100%"
              />
            </td>
            <td class="ts-py-1 ts-px-2">
              <div class="ts-flex ts-justify-between">
                <p>$</p>
                <b>{{ detail.fee_amount * detail.quantity }}</b>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="9" class="ts-text-right ts-px-4 ts-py-2">
              <label class="required">{{
                $t('paymentAdjustment.paymentMethod')
              }}</label>
            </td>
            <td>
              <a-select
                v-model.number="model.payment_method_id"
                :options="paymentMethods"
                class="ts-w-full"
                @change="onPaymentMethodChange"
              ></a-select>
              <div class="validate" v-if="errors.has('payment_method_id')">
                {{ errors.first('payment_method_id') }}
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="9" class="ts-text-right ts-px-4 ts-py-2">
              <label :class="model.payment_method_id != 1 ? 'required' : ''">{{
                $t('paymentAdjustment.bank')
              }}</label>
            </td>
            <td>
              <a-select
                v-model.number="model.bank_id"
                :options="bank"
                class="ts-w-full"
              ></a-select>
              <div class="validate" v-if="errors.has('bank_id')">
                {{ errors.first('bank_id') }}
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="9" class="ts-text-right ts-px-4 ts-py-2">
              <label>{{ $t('paymentAdjustment.nextPaymentDate') }}</label>
            </td>
            <td>
              <a-date-picker
                :style="{ width: '100%' }"
                format="DD-MM-YYYY"
                valueFormat="DD-MM-YYYY"
                v-model="model.next_payment_date"
              />
              <div class="validate" v-if="errors.has('next_payment_date')">
                {{ errors.first('next_payment_date') }}
              </div>
            </td>
          </tr>
          <tr>
            <td
              colspan="9"
              class="ts-text-right ts-px-4 ts-py-2"
              valign="middle"
            ></td>
            <td>
              <ts-checkbox v-model="model.is_print">{{
                $t('paymentAdjustment.previewPdf')
              }}</ts-checkbox>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </ts-loading-banner>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { uniqBy, sumBy } from 'lodash'
import moment from 'moment'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'invoiceItemDetail',
  props: ['value', 'validate'],
  data() {
    return {
      errors: new Errors(),
      student_id: undefined,
      loading: false,
      feeTypes: [],
      model: {},
      feeItems: [],
      firstInvoice: 0,
      bank: [],
      row: {
        old_fee_setup_id: '',
        fee_type_id: '',
        fee_setup_id: '',
        fee_description: '',
        quantity: 1,
        fee_start_date: '',
        fee_end_date: '',
        payment_term_id: '',
        duration_in_month: '',
        fee_amount: '',
        ac_term_id: '',
        grade_id: '',
        shift_id: '',
        payment_term_name: '',
        pro_type_id: ''
      }
    }
  },
  computed: {
    getFeeItem: vm => feeTypeId => {
      if (feeTypeId != undefined) {
        let item = vm.feeItems[feeTypeId]
        if (item) {
          return item.map(el => ({
            value: el.fee_setup_id,
            label: el.fee_name,
            obj: el
          }))
        }
        return []
      }
      return []
    },
    paymentMethods() {
      return [
        { value: 1, label: 'Cash' },
        { value: 2, label: 'Cheque' },
        { value: 3, label: 'Bank Transfer' },
        { value: 4, label: 'Credit Card' }
      ]
    }
  },
  created() {
    this.model = this.value
    this.fetchFeeType()
  },
  methods: {
    ...mapActions('paymentAdjustment', ['formViewModel']),
    fetchFeeType() {
      this.loading = true
      this.formViewModel({
        fnName: 'feeType'
      })
        .then(({ feeType }) => {
          this.feeTypes = feeType
        })
        .finally(() => (this.loading = false))
    },
    fetchInvoiceDetail() {
      this.loading = true
      this.formViewModel({
        fnName: 'invoiceDetail',
        inv_id: this.value.inv_id
      })
        .then(({ invoiceDetail }) => {
          this.model.inv_detail_list = []
          this.firstInvoice = invoiceDetail.total_amount
          this.student_id = invoiceDetail.student_id
          invoiceDetail.invoice_detail.forEach(item => {
            this.model.inv_detail_list.push({
              old_fee_setup_id: item.fee_setup_id,
              fee_type_id: item.fee_type_id,
              fee_setup_id: item.fee_setup_id,
              old_fee_setup_name: item.fee_name_en,
              fee_description: item.fee_description,
              quantity: 1,
              fee_start_date: item.fee_start_date,
              fee_end_date: item.fee_end_date,
              payment_term_id: item.payment_term_id,
              duration_in_month: item.duration_in_month,
              fee_amount: item.total_amount,
              ac_term_id: item.ac_term_id,
              grade_id: item.grade_id,
              shift_id: item.shift_id,
              payment_term_name: item.payment_term_name,
              pro_type_id: item.pro_type_id
            })

            this.feeItems = Object.assign({}, this.feeItems, {
              [item.fee_type_id]: [
                {
                  fee_type_id: item.fee_type_id,
                  fee_setup_id: item.fee_setup_id,
                  fee_name: item.fee_name_en,
                  fee_start_date: item.fee_start_date,
                  fee_end_date: item.fee_end_date,
                  payment_term_id: item.payment_term_id,
                  duration_in_month: item.duration_in_month,
                  fee_amount: item.total_amount,
                  ac_term_id: item.ac_term_id,
                  grade_id: item.grade_id,
                  shift_id: item.shift_id,
                  payment_term_name: item.payment_term_name,
                  pro_type_id: item.pro_type_id
                }
              ]
            })

            this.calculate()
          })
        })
        .finally(() => (this.loading = false))
    },
    fetchItemDetail(param) {
      uniqBy(this.model.inv_detail_list, 'fee_type_id').forEach(el => {
        this.loading = true
        return this.formViewModel({
          fnName: 'feeItemDetail',
          student_id: param.student_id,
          ac_term_id: param.ac_term_id,
          grade_id: param.grade_id,
          fee_type_id: el.fee_type_id,
          room_type_id: param.room_type_id
        })
          .then(response => {
            if (!Array.isArray(response.feeItemDetail)) {
              this.feeItems = Object.assign(
                {},
                this.feeItems,
                response.feeItemDetail
              )
            }
          })
          .finally(() => (this.loading = false))
      })
    },
    calculate() {
      let invoiceAmount = sumBy(this.model.inv_detail_list, o => {
        return o.quantity * o.fee_amount
      })
      this.model.new_inv_amount = invoiceAmount
      this.model.adj_amount = invoiceAmount - this.firstInvoice

      if (this.model.adj_amount != 0) {
        this.model.next_payment_date = moment().format('DD-MM-YYYY')
      } else {
        this.model.next_payment_date = undefined
      }
    },
    onFeeSetupChange(detail, prop) {
      let item = prop.data.props.obj
      detail.fee_setup_id = item.fee_setup_id
      detail.fee_description = item.fee_name
      detail.fee_start_date = item.fee_start_date
      detail.fee_end_date = item.fee_end_date
      detail.payment_term_id = parseInt(item.payment_term_id)
      detail.duration_in_month = parseInt(item.duration_in_month)
      detail.fee_amount = parseFloat(item.fee_amount)
      detail.ac_term_id = parseInt(item.ac_term_id)
      detail.grade_id = parseInt(item.grade_id)
      detail.shift_id = parseInt(item.shift_id)
      detail.payment_term_name = item.payment_term_name
      detail.pro_type_id = parseInt(item.pro_type_id)
      this.calculate()
    },
    onPaymentMethodChange() {
      if (this.model.payment_method_id == 1) {
        this.model.bank_id = null
      } else {
        this.loading = true
        this.formViewModel({
          fnName: 'bank',
          student_id: this.student_id
        })
          .then(({ bank }) => {
            this.bank = bank
            var b = this.bank.find(b => parseInt(b.is_default) == 1)
            if (b) {
              this.model.bank_id = b.value
            }
          })
          .finally(() => (this.loading = false))
      }
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
